import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { PageHeader } from "@/components/ui/page-header";
import { Spinner } from "@/components/ui/spinner";
import { ProfileSidebar } from "../components/ProfileSidebar";
import { individualSelectors } from "../redux/individual/selectors";

export const Account = () => {
  const location = useLocation();
  const email = useSelector(individualSelectors.selectEmail);

  let headerTitle;
  if (!email) {
    headerTitle = <Spinner />;
  } else {
    headerTitle = location.pathname.includes("account/profile")
      ? "Profile"
      : "Payment";
  }

  return (
    <div className="h-full w-full overflow-y-auto bg-surface">
      <div className="mx-auto flex w-full max-w-190 flex-col gap-8 px-12 pt-10 pb-24">
        <PageHeader title={headerTitle} />
        <div className="flex w-full flex-col items-start gap-8 lg:flex-row">
          <ProfileSidebar />
          <div className="w-full min-w-0">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
